import ServiceWrapper, { type ServiceOptions } from "@utils/ServiceWrapper";
import { BACKDOOR_USER, USER_ACTIVE_SCHOOL_YEAR, USER_SCHOOL_YEAR_RANGE } from "@const/UserConst";

export type UserAction = "activeSchoolYearRead" | "userDetailsRead" | "userSchoolYearRange";

interface UserDaoOptions {
    action: UserAction;
    params?: unknown;
    schoolYearKey?: number | string | null;
    username?: string | null;
    icId?: number | null;
    signal?: AbortSignal;
}

/**
 * Data Access Object for the User API.
 * Uses the actionConfig pattern from VOE.
 */
const UserDao = <T = unknown>(options: UserDaoOptions): Promise<{ data: T }> | null => {
    const { action, schoolYearKey, username, signal } = options;

    const requestOptions: ServiceOptions = { url: "", method: "GET", signal };

    const actionConfig: Record<string, Partial<ServiceOptions>> = {
        activeSchoolYearRead: { method: "GET", url: USER_ACTIVE_SCHOOL_YEAR },
        userDetailsRead: { method: "GET", url: `${BACKDOOR_USER}/${username}/detail.json` },
        userSchoolYearRange: { method: "GET", url: `${USER_SCHOOL_YEAR_RANGE}/${schoolYearKey}/detail.json` }
    };

    const config = actionConfig[action];
    if (!config) {
        const error = new Error(`UserDao: Invalid action "${action}" provided`);
        console.error("UserDao: Invalid action provided");
        throw error;
    }

    return ServiceWrapper.serviceCall({
        options: { ...requestOptions, ...config }
    }) as Promise<{ data: T }>;
};

export default UserDao;
